export const CATEGORY_ORDER: { tag: string; label: string }[] = [
  { tag: 'popular', label: 'Popular' },
  { tag: 'hong-kong', label: 'Hong Kong' },
  { tag: 'apac', label: 'APAC' },
  { tag: 'erp', label: 'ERP' },
  { tag: 'crm', label: 'CRM' },
  { tag: 'ecommerce', label: 'eCommerce' },
  { tag: 'payments', label: 'Payments' },
  { tag: 'shipping-logistics', label: 'Shipping & Logistics' },
  { tag: 'marketing-automation', label: 'Marketing Automation' },
  { tag: 'ipaas', label: 'iPaaS' },
  { tag: 'project-management', label: 'Project Management' },
  { tag: 'banking', label: 'Banking' },
];

export function getCategoryLabel(tag: string): string {
  return CATEGORY_ORDER.find((c) => c.tag === tag)?.label ?? tag;
}
